import { render, staticRenderFns } from "./promoteStateCell.vue?vue&type=template&id=2d58f8fe&scoped=true"
import script from "./promoteStateCell.vue?vue&type=script&lang=js"
export * from "./promoteStateCell.vue?vue&type=script&lang=js"
import style0 from "./promoteStateCell.vue?vue&type=style&index=0&id=2d58f8fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d58f8fe",
  null
  
)

export default component.exports